/* BBO Sticky Add to Cart — product pages only */
(function () {
  'use strict';

  const HIDDEN_CLASS = 'bbo-sticky--hidden';

  function init() {
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;

    const mainBtn = form.querySelector('[name="add"]');
    if (!mainBtn) return;

    // Build sticky bar
    const bar = document.createElement('div');
    bar.className = 'bbo-sticky-cart ' + HIDDEN_CLASS;
    bar.setAttribute('aria-hidden', 'true');

    const title = document.querySelector('.product__title')?.textContent?.trim() || '';
    const priceEl = document.querySelector('.price__regular .price-item, .price__sale .price-item--sale');
    const price = priceEl?.textContent?.trim() || '';

    bar.innerHTML = `
      <div class="bbo-sticky-cart__inner">
        <div class="bbo-sticky-cart__info">
          <span class="bbo-sticky-cart__title">${title}</span>
          <span class="bbo-sticky-cart__price">${price}</span>
        </div>
        <button type="button" class="bbo-sticky-cart__btn" id="bbo-sticky-btn">
          ADD TO CART
        </button>
      </div>
    `;

    document.body.appendChild(bar);

    // Observe main button visibility
    const observer = new IntersectionObserver(
      ([entry]) => {
        const hidden = entry.isIntersecting;
        bar.classList.toggle(HIDDEN_CLASS, hidden);
        bar.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      },
      { threshold: 0.2 }
    );
    observer.observe(mainBtn);

    // Sync sold out / unavailable state
    const mutObs = new MutationObserver(() => {
      const stickyBtn = bar.querySelector('#bbo-sticky-btn');
      const disabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
      const sold = mainBtn.textContent?.toLowerCase().includes('sold') ||
                   mainBtn.textContent?.toLowerCase().includes('unavailable');
      stickyBtn.disabled = disabled || sold;
      stickyBtn.textContent = sold ? 'SOLD OUT' : 'ADD TO CART';
    });
    mutObs.observe(mainBtn, { attributes: true, childList: true, characterData: true, subtree: true });

    // Click — submit the real form
    bar.querySelector('#bbo-sticky-btn').addEventListener('click', () => {
      if (mainBtn.disabled) return;
      mainBtn.click();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
